/**
 * @generated SignedSource<<8b348ec545ddb84ebb00613cd13354c7>>
 * @relayHash 630bda5978f017d66aa616a0a7b2cc3d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ef4a123bf1a5e07531ecec30a4e8e27da71983f3aded136721f84e25ec4c7f56

import type { ConcreteRequest } from 'relay-runtime';
export type EditorMovePageButtonQuery$variables = {
  contentId: string;
};
export type EditorMovePageButtonQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null | undefined;
      readonly operations: ReadonlyArray<{
        readonly operation: string | null | undefined;
        readonly targetType: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly status: string | null | undefined;
      readonly type: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type EditorMovePageButtonQuery = {
  response: EditorMovePageButtonQuery$data;
  variables: EditorMovePageButtonQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      },
      {
        "kind": "Literal",
        "name": "status",
        "value": [
          "current",
          "draft"
        ]
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "kind": "ScalarField",
            "name": "type"
          },
          {
            "kind": "ScalarField",
            "name": "status"
          },
          {
            "concreteType": "OperationCheckResult",
            "kind": "LinkedField",
            "name": "operations",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "operation"
              },
              {
                "kind": "ScalarField",
                "name": "targetType"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "EditorMovePageButtonQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditorMovePageButtonQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "630bda5978f017d66aa616a0a7b2cc3d",
    "id": "ef4a123bf1a5e07531ecec30a4e8e27da71983f3aded136721f84e25ec4c7f56",
    "metadata": {},
    "name": "EditorMovePageButtonQuery",
    "operationKind": "query",
    "text": "query EditorMovePageButtonQuery($contentId:ID!){content(id:$contentId,status:[\"current\",\"draft\"]){nodes{id,type,status,operations{operation,targetType}}}}"
  }
};
})();

(node as any).hash = "54029c77ef9a7e56f195b24f87d3c3ed";

export default node;
